// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"lighthouse-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8 10V3.6L12 2L16 3.6V10C16 15 18 22 18 22H14L13 18H11L10 22H6C6 22 8 15 8 10Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 4.1V10C8 15 6 22 6 22H10L11 18H13L14 22H18C18 22 16 15 16 10V4.1M6 11H18M7 4L12 2L17 4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 6.99805H12.0039V7.00195H12V6.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Lighthouse1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lighthouse-1',
    ref,
    icon: element,
  },
));

Lighthouse1Icon.displayName = 'Lighthouse1Icon';

export default Lighthouse1Icon;
